import { render, staticRenderFns } from "./PurchaseInfoVat.vue?vue&type=template&id=1d8a605d&scoped=true"
import script from "./PurchaseInfoVat.vue?vue&type=script&lang=ts"
export * from "./PurchaseInfoVat.vue?vue&type=script&lang=ts"
import style0 from "./PurchaseInfoVat.vue?vue&type=style&index=0&id=1d8a605d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8a605d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d8a605d')) {
      api.createRecord('1d8a605d', component.options)
    } else {
      api.reload('1d8a605d', component.options)
    }
    module.hot.accept("./PurchaseInfoVat.vue?vue&type=template&id=1d8a605d&scoped=true", function () {
      api.rerender('1d8a605d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseInfoVat.vue"
export default component.exports